import React, { useState, useCallback } from 'react';

const DependentEffectContext = React.createContext();

export const DependentEffectProvider = ({ children }) => {
  const [stateId, setStateId] = useState(0);
  const handleUpdate = useCallback(() => {
    setStateId(sId => sId + 1);
  }, []);

  return (
    <DependentEffectContext.Provider value={{ update: handleUpdate, stateId }}>
      {children}
    </DependentEffectContext.Provider>
  );
};

export default DependentEffectContext;
